import type { I18nService } from '../../../core';

export interface CommentDateConfig { dateFieldId: string; overrideDateFieldId?: string | null }

export function commentDateConfig(value: unknown): CommentDateConfig | null {
  if (typeof value === 'string') {
    try { value = JSON.parse(value); } catch { return null; }
  }
  if (!value || typeof value !== 'object') return null;
  const raw = value as Record<string, unknown>;
  if (typeof raw['dateFieldId'] !== 'string') return null;
  const alternative = raw['overrideDateFieldId'];
  if (alternative != null && typeof alternative !== 'string') return null;
  return { dateFieldId: raw['dateFieldId'], overrideDateFieldId: alternative as string | null | undefined };
}

export function isCommentConditionValid(value: unknown, operator: string): boolean {
  const config = commentDateConfig(value);
  const guid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const validId = (id: string) => guid.test(id) && id !== '00000000-0000-0000-0000-000000000000';
  return !!config && ['IsEmpty', 'IsNotEmpty'].includes(operator) && validId(config.dateFieldId)
    && (!config.overrideDateFieldId || (validId(config.overrideDateFieldId)
      && config.overrideDateFieldId.toLowerCase() !== config.dateFieldId.toLowerCase()));
}

export function commentConditionLabel(i18n: I18nService, value: unknown, operator: string,
  fields: readonly { fieldId: string; name: string }[] = []): string {
  const config = commentDateConfig(value);
  const name = (id: string | null | undefined) => fields.find(f => f.fieldId === id)?.name
    ?? i18n.t('features.automations.comments.dateField');
  const label = i18n.t(operator === 'IsEmpty' ? 'features.automations.comments.noCommentSince'
    : 'features.automations.comments.hasCommentSince', { field: name(config?.dateFieldId) });
  return config?.overrideDateFieldId ? `${label} · ${i18n.t('features.automations.comments.overrideSummary',
    { field: name(config.overrideDateFieldId) })}` : label;
}
